"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
var _sharedComponents = require("@site/shared-components");
var _constants = require("./constants");
var _reactMintl = require("@godaddy/react-mintl");
var _utils = require("@site/utils");
var _BasePriceBlock = _interopRequireDefault(require("./BasePriceBlock"));
var _priceComparisonCardStyle = _interopRequireDefault(require("./styles/priceComparisonCardStyle"));
const PriceComparisonCard = ({
  language = {},
  domainPrice = {},
  selected = false,
  bestValue = false,
  renewalPriceInTotal = false
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const market = (0, _utils.getMarket)();
  const savingToDisplay = (0, _utils.calculatePriceSavingsDisplay)({
    actualCurrentPrice: domainPrice.FullTermSalePrice,
    listPrice: domainPrice.FullTermListPrice,
    moneySavingsMessage: _constants.baseMessages.moneySavings,
    formatMessage
  });
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: language
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _priceComparisonCardStyle.default,
    "data-testid": "price-comparison-card",
    "data-cy": "price-comparison-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'card-price-best-value': bestValue
    })
  }, bestValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-2 font-weight-bold p-1"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _constants.baseMessages.domainbestValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('price-card', {
      'p-3': !selected,
      'card-price-padding price-card-selected': selected
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: formatMessage({
      id: _constants.baseMessages.yearTerm
    }, {
      term: domainPrice.Term
    }),
    color: _sharedComponents.TAG_COLORS.SECONDARY
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: savingToDisplay,
    color: _sharedComponents.TAG_COLORS.WARNING
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex align-items-center justify-content-center card-check', {
      'bg-black': selected
    })
  }, selected && /*#__PURE__*/_react.default.createElement(_checkmark.default, {
    bold: true,
    width: 12,
    height: 12,
    className: "font-weight-bold text-white"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement(_BasePriceBlock.default, {
    language: language,
    currentPriceDisplay: domainPrice.FullTermSalePriceDisplay,
    initialPriceDisplay: domainPrice.FullTermListPriceDisplay,
    options: {
      showPriceOnly: true,
      classNames: {
        priceCurrent: 'font-weight-bold'
      }
    }
  })), /*#__PURE__*/_react.default.createElement("hr", {
    className: "w-100 my-1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "price-list-content"
  }, Array.from({
    length: domainPrice.Term
  }, (_, index) => /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex mt-1",
    key: index
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('px-1 ms-2 ', {
      'price-card-list': index === 0
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _constants.baseMessages.numberOfYearPrice,
    values: {
      numberOfYear: index + 1,
      yearlyPrice: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "font-weight-bold ml-2"
      }, " ", index === 0 ? domainPrice.FirstYearSalePriceDisplay : domainPrice.AdditionalYearsSalePriceDisplay, " "))
    }
  }))))), /*#__PURE__*/_react.default.createElement("hr", {
    className: "w-100 my-2"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "font-weight-bold ms-2"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _constants.baseMessages.total,
    values: {
      totalPrice: domainPrice.FullTermSalePriceDisplay
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-2 mt-2",
    "data-testid": "renewal-price"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _constants.baseMessages.domainRenews,
    values: {
      price: renewalPriceInTotal ? domainPrice.RenewalListPriceDisplay : domainPrice.AdditionalYearsSalePriceDisplay
    }
  }))))));
};
PriceComparisonCard.propTypes = {
  language: _propTypes.default.object.isRequired,
  domainPrice: _propTypes.default.shape({
    Term: _propTypes.default.number,
    FirstYearSalePrice: _propTypes.default.number,
    FirstYearSalePriceDisplay: _propTypes.default.string,
    AdditionalYearsSalePrice: _propTypes.default.number,
    AdditionalYearsSalePriceDisplay: _propTypes.default.string,
    FullTermSalePrice: _propTypes.default.number,
    FullTermSalePriceDisplay: _propTypes.default.string,
    FullTermListPrice: _propTypes.default.number,
    FullTermListPriceDisplay: _propTypes.default.string,
    RenewalSalePrice: _propTypes.default.number,
    RenewalSalePriceDisplay: _propTypes.default.string,
    RenewalListPrice: _propTypes.default.number,
    RenewalListPriceDisplay: _propTypes.default.string
  }).isRequired,
  selected: _propTypes.default.bool,
  bestValue: _propTypes.default.bool,
  renewalPriceInTotal: _propTypes.default.bool
};
var _default = exports.default = PriceComparisonCard;